import { TextField, styled } from "@mui/material";

/**
 * Componente de campo de texto personalizado con estilos CSS.
 * @param {object} props - Propiedades del componente.
 * @returns {JSX.Element} Elemento del campo de texto personalizado.
 */

export const CssTextField = styled(TextField, {
  shouldForwardProp: (prop) => !["helper", "borderColor"].includes(prop),
})(({ theme, helper }) => ({
  width: "97%",
  fontFamily: "Lexend",
  borderRadius: 10,
  marginTop: 10,
  "& label.Mui-focused": {
    color: helper
      ? "#D32F2F"
      : theme.palette.mode === "dark"
        ? "white"
        : "green",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: helper
      ? "#D32F2F"
      : theme.palette.mode === "dark"
        ? "white"
        : "green",
    borderBottomLeftRadius: 10,
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopRightRadius: 10,
    borderWidth: 3,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 10,
      borderTopRightRadius: 10,
      borderWidth: 3,
    },
    "&:hover fieldset": {
      borderColor: helper ? "#D32F2F" : "yellow",
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 10,
      borderTopRightRadius: 10,
      borderWidth: 3,
    },
    "&.Mui-focused fieldset": {
      borderColor: helper
        ? "#D32F2F"
        : theme.palette.mode === "dark"
          ? "white"
          : "green",
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 10,
      borderTopRightRadius: 10,
      borderWidth: 3,
    },
    "& input:-webkit-autofill": {
      backgroundColor: "transparent !important",
      WebkitBoxShadow: "0 0 0 30px white inset !important", // Esto elimina el fondo amarillo
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 10,
      borderTopRightRadius: 10,
    },
  },
}));
